var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"d-flex align-center text-decoration-none",attrs:{"to":"/"}},[_c('v-img',{staticClass:"me-3",attrs:{"src":_vm.themeConfig.app.logo,"height":"45px","width":"45px","alt":"logo","contain":""}}),_c('h2',{staticClass:"font-semibold text-xl text-primary"},[_vm._v(" "+_vm._s(_vm.themeConfig.app.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }